// Libs
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Selectors
import { productsObjSelector } from '../../../store/selectors';

// Actions
import { GetSharedKits } from '../../../actions/sharedKits';

const useSharedKits = () => {
  const dispatch = useDispatch();
  const searchValue = useSelector((state) => state.search);
  const productsStorage = useSelector((state) => productsObjSelector(state));
  const apiError = useSelector((state) => state.apiError?.['getSharedKits']);
  const { isLoading, sharedKits } = useSelector((state) => ({
    isLoading: state.isLoading,
    sharedKits: state.sharedKits || { data: null },
  }));

  const filteredKits = useMemo(() => {
    if (!searchValue) {
      return sharedKits.data;
    }

    const queries = searchValue.toLowerCase().split(' ');

    return sharedKits.data?.filter(
      (kit) =>
        queries.every((query) => kit.name.toLowerCase().includes(query)) ||
        kit.products.some((item) =>
          queries.every(
            (query) =>
              item.product.toLowerCase().includes(query) ||
              productsStorage[item.product]?.product_description
                ?.toLowerCase()
                .includes(query),
          ),
        ),
    );
  }, [sharedKits.data, productsStorage, searchValue]);

  useEffect(() => {
    dispatch(GetSharedKits());
  }, [dispatch]);

  return {
    isLoading,
    sharedKits,
    filteredKits,
    apiError,
  };
};

export default useSharedKits;
